import { render, staticRenderFns } from "./ChapterSettings.vue?vue&type=template&id=32254f5a&"
import script from "./ChapterSettings.vue?vue&type=script&lang=js&"
export * from "./ChapterSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports